import { Tag } from "antd";
import { ANALYSIS_SOURCE_TAG } from "../../../entities/entities";

const SourceTag = ({ source, text = null, ...rest }) => {
  const cfg = ANALYSIS_SOURCE_TAG[source];
  return (
    <Tag color={cfg.color} {...rest}>
      {text ?? cfg.label}
    </Tag>
  );
};
export default SourceTag;
